/* global document */
export default function overlayButton() {
    document.querySelector('.js-overlay-hide-button').addEventListener('click', (ev) => {
        ev.preventDefault();
        document.querySelector('.js-overlay').style.display = 'none';
    });
}
